import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as routes from 'config/routes';
import { MainLayout } from 'layouts/MainLayout';
import { Box, Tab, Tabs } from '@mui/material';
import { EReportingListAlias } from 'components/pepper-pay/block-list/enums';
import { Schedules } from './schedules';
import { Reporting } from './reporting';

export const ReportingPage: React.FC = () => {
    const navigate = useNavigate();
    const { table } = useParams<{ table: string }>();

    const buttons: { key: EReportingListAlias; label: string }[] = React.useMemo(
        () => [
            {
                label: 'Report List',
                key: EReportingListAlias.REPORTING
            },
            {
                label: 'Schedules',
                key: EReportingListAlias.SCHEDULES
            }
        ],
        []
    );

    const renderButton = React.useCallback(
        ({ label, key }: { label: string; key: string }) => (
            <Tab value={key} key={`tab-${key}`} label={<span>{label}</span>} />
        ),
        []
    );

    const handleChange = React.useCallback(
        (_: never, table: EReportingListAlias) => {
            if (table === EReportingListAlias.REPORTING) {
                navigate(routes.PEPPER_PAY_REPORTING_REPORTS);
            }
            if (table === EReportingListAlias.SCHEDULES) {
                navigate(routes.PEPPER_PAY_REPORTING_SCHEDULES);
            }
        },
        [navigate]
    );

    return (
        <MainLayout pageName="Reporting" pageDescription="View and generate reports">
            <Tabs value={table} onChange={handleChange} variant="scrollable" indicatorColor="primary">
                {buttons.map(renderButton)}
            </Tabs>

            <Box>
                {table === EReportingListAlias.REPORTING && <Reporting />}
                {table === EReportingListAlias.SCHEDULES && <Schedules />}
            </Box>
        </MainLayout>
    );
};
